import { HTMLAttributes, useMemo } from 'react'

import Container from '@/components/base/container'
import BaseHeading from '@/components/base/heading'
import Search, { SearchProps } from '@/components/base/search'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'
import WishlistTools from '@/components/base/wishlist-tools'
import { getTitleFromSchema, useSchema } from '@/contexts/schema'

export type HeadingProps = HTMLAttributes<HTMLDivElement> &
  Pick<SearchProps, 'onSubmit' | 'onChange'> &
  Partial<{
    use_search: boolean
    use_wishlist_tools: boolean
    search_placeholder: string
    fetching: boolean
  }>

const Heading = ({
  use_search = false,
  use_wishlist_tools = false,
  search_placeholder = 'Cerca',
  fetching = false,
  onSubmit,
  onChange,
  ...props
}: HeadingProps) => {
  const { schema } = useSchema()
  const title = useMemo(() => getTitleFromSchema(schema), [schema])

  return (
    <Section {...props}>
      <Container>
        <BaseHeading
          schema={schema}
          search={
            use_search ? (
              <Search
                className="w-full md:w-auto"
                placeholder={search_placeholder}
                onSubmit={onSubmit}
                onChange={onChange}
                fetching={fetching}
              />
            ) : null
          }
          tools={use_wishlist_tools ? <WishlistTools /> : undefined}
        >
          <Typography variant="main-title-default" component="h1">
            {title}
          </Typography>
        </BaseHeading>
      </Container>
    </Section>
  )
}

export default Heading
